import axios from "./axios";
import RestfulService from "api/common/RestfulService";
// TODO merge with esg-admin/organization-adminApi.js

export const organizationService = new RestfulService("/administration/organization");

const api = {
  getOrganizationId(subdomain) {
    return axios.get("/public/organizations", { params: { subdomain: subdomain } }).then(({ data }) => data);
  },

  getOrganizationSubDomain(organizationId) {
    return axios
      .get("/public/organizations/subdomain", { params: { org_id: organizationId } })
      .then(({ data }) => data);
  },

  getOrganizationUsers(accessToken) {
    const headers = {
      headers: { Authorization: `Bearer ${accessToken}` },
    };

    return axios.get("/users/organization-members", headers).then(({ data }) => data);
  },

  getSupplierUsers(supplierId, accessToken) {
    const headers = {
      headers: { Authorization: `Bearer ${accessToken}` },
    };
    return axios.get(`/users/suppliers/${supplierId}`, headers).then(({ data }) => data);
  },

  getOrganizationDivisions(accessToken) {
    const headers = {
      headers: { Authorization: `Bearer ${accessToken}` },
    };
    return axios.get("/divisions", headers).then(({ data }) => data);
  },

  getAllSuppliers(accessToken) {
    const headers = {
      headers: { Authorization: `Bearer ${accessToken}` },
    };
    return axios.get("/suppliers", headers).then(({ data }) => data);
  },

  getOrganizationStructure(accessToken) {
    const headers = {
      headers: { Authorization: `Bearer ${accessToken}` },
    };
    return axios.get("/public/organizations/structure", headers).then(({ data }) => data);
  },

  // HACK: Global.organizationModules is set by AuthProvider by calling this function
  useGetOrganizationModules() {
    return axios.get("/public/organizations/modules").then(({ data }) => data);
  },

  getOrganizationAssociations(email) {
    return axios.get("/public/organizations/association", { params: { email: email } }).then(({ data }) => data);
  },
};

export default api;
